import { AxiosResponse } from "axios";
import { isCancelExistingConfirmationResponse } from "../../../features/Booking-Form/typings/cancel-existing-booking.types";
import { BookingStrategyContext } from "./bookingStrategies";

type WriteContext = Pick<
  BookingStrategyContext,
  "onSuccess" | "onError" | "onCancelExistingConfirmationRequired"
>;

export async function runBookingWriteWithCancelConfirm(
  post: (confirmCancelExistingBookings?: boolean) => Promise<AxiosResponse<unknown>>,
  ctx: WriteContext
): Promise<void> {
  try {
    const response = await post();
    if (isCancelExistingConfirmationResponse(response.data)) {
      ctx.onCancelExistingConfirmationRequired(response.data.affectedBookings, () => {
        runBookingWriteWithCancelConfirm(() => post(true), ctx);
      });
      return;
    }
    ctx.onSuccess();
  } catch (err) {
    ctx.onError(err);
  }
}
